const translate = {
  portugues: {
    title: "minha conta",
    subTitle: "Informe seus dados de acesso abaixo.",
    titleBanner: "Assine Agora!",
    subTitleBanner: "É fácil, rápido e seguro.",
    legendBanner: "Escolha o melhor plano para você e assine agora mesmo!",
    placeHolderEmail: "Informe seu email / login",
    placeHolderPassword: "Informe sua senha",
    buttonLabel: "Entrar",
    labelInformation:
      "Minha Conta é uma área destinada ao assinante do Bella da Semana. Aqui você pode:",
    listActivity: [
      "Conferir o histórico de pagamentos da sua assinatura",
      "Colocar sua assinatura do Bella da Semana em dia",
      "Imprimir a 2a via do boleto bancário",
      "Atualizar seus  dados cadastrais (e-mail e senha)",
    ],
    imgDefault: {
      name: "Nome da Modelo",
      src: "https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg",
    },
    imgBannerRodape: {
      name: "Nome Banner Rodape",
      src: "https://api.belladasemana.com.br/storage/banners/1539015349.jpg",
    },
    hello: "Olá",
    sweetDo: "escolha o que deseja fazer",
    // Aba exclusiva do assinante Gold. Fica FORA do array navBar de propósito:
    // os índices do array são os `val` dos painéis (deep links ?tab=N).
    navBarAreaGold: "Área GOLD",
    navBar: [
      "Renovar / Upgrade",
      "Créditos de Download",
      /*"Cancelar assinatura",*/
      /*'Alterar forma de pagamento', 'Alterar plano',*/ "Histórico de compras",
      "Alterar dados cadastrais",
      "Convide seu amigo",
    ],
    historyTitle: "Meu histórico de compras",
    codeshare: "Gere aqui seu codigo de compartilhamento",
    historySubtitle: "Aqui você pode conferir todos seus pagamentos efetuados.",
    userSubtitle: "Aqui você pode conferir todos os dados da sua conta. ",
    placeholderNickname: "Nickname",
    placeholderEmail: "Seu e-mail",
    labelNewsletter: "Receber newsletter:",
    labelPromotions: "Receber promoções:",
    yes: "Sim",
    no: "Não",
    placeholderPassword: "Nova senha",
    placeholderRepitePassoword: "Redigite sua senha",
    placeholderCurrentPassword: "Senha atual",
    msgCurrentPasswordRequired: "Informe sua senha atual para trocar a senha.",
    msgNewPasswordRequired:
      "Informe a nova senha e a confirmação para trocar a senha.",
    msgPasswordMismatch: "A nova senha e a confirmação não coincidem.",
    buttonLabelSave: "Salvar",
    titleCancel: "Não quer mais assinar o Bella?",
    subtitleCancel:
      "Se você tem certeza que quer cancelar sua assinatura, confirme abaixo:",
    infoCancel1:
      "O cancelamento passa a vigorar ao fim deste ciclo de cobrança:",
    labelOptionCancel: "Selecione o motivo do cancelamento de sua assinatura:",
    buttonLabelCancel: "Solicitar cancelamento",
    inputCancelMessage: "Outros (especifique abaixo)",
    infoCancel2:
      "Volte quando quiser. Se você reiniciar sua assinatura dentro de 2 meses, seus perfis, seus favoritos, suas preferências e os detalhes da sua conta estarão aguardando por você.",
    listMotivosCancel: [
      "Preço da assinatura",
      "Qualidade dos ensaios",
      "Pouca nudez",
      "Frequência de atualizações",
      "Conteúdo diferente do que esperava",
      "Estou satisfeito com o conteúdo aberto",
      "Dificuldade no acesso",
      "Outros (especifique abaixo)",
    ],
    listMotivosCancelName: [
      "price",
      "quality",
      "little_nudity",
      "updates_frequency",
      "expected_different_content",
      "satisfied_opened_content",
      "difficult_access",
      "none_above",
    ],
    forgotPwd1: "Se você esqueceu sua senha, ",
    forgotPwd2: "clique aqui",
    orderType: "Tipo",
    orderStatus: "Status",
    orderPlanName: "Plano",
    orderPlanValue: "Valor",    
    orderMethodName: "Forma de pagamento",
    orderStart: "Início",
    orderFinish: "Fim",
    noOrders: "Nenhuma ordem encontrada",
    alertMessageOrderActived:
      "Você já possui uma assinatura ativa! Só é possivel renovar após o vencimento no dia: ",
    placeholderMessage: "Mensagem",
    setReasonCancel: "Informe algum motivo!",
    setMessageReasonCancel: "Informe Outro(s) motivos na Mensagem!",
    cancelAttention: "Atenção!",
    notCancelledYet:
      "Sua assinatura <b>AINDA NÃO FOI CANCELADA!</b><br><br>Uma mensagem de confirmação será enviada para seu email.<br> Lembre-se de verificar a caixa de Spam ou Lixeira.<br><br> <b>PARA CONFIRMAR SEU PEDIDO DE CANCELAMENTO,<br> VOCÊ DEVE CLICAR NO LINK ENVIADO PARA SEU E-MAIL.</b>",
    notSubscribe: "Nenhuma assinatura ativa.",
    msgWaiting: "Aguarde o processamento...",
    msgSendMail: "Informe seu email abaixo",
    btnSendMail: "Enviar",
    btnClose: "Fechar",
    pwdReset: "Redefinição de Senha",
    formResetEmail: "E-mail",
    formResetPwd: "Nova senha",
    formResetPwdConfirm: "Confirme sua senha",
    formResetButton: "Salvar",
    checkFailedText1: "Link expirado!",
    checkFailedText2:
      "Por favor, repita o procedimento de recuperação de senha.",
    checkFailedText3: "Ir para página de redefinição de senha",
    msgSuccess: "Ir para página de login",
    footer1ModalPlan: "jÁ É SÓCIO?",
    footer2ModalPlan: "FAÇA LOGIN PARA COMPRAR CRÉDITOS COM DESCONTO",
    buttonCredits: "Clique aqui",
    shareCodeSubtitle1:
      "Presenteie seu amigão com <strong>1 mês grátis no Clube Bella!<strong/><br>É bem simples: gere seu código-presente e envie para ele.",
    passosCodeShare: [
      "Clicar no seu link de convite.",
      "Escolher o Plano Basic (opção Mensal).",
      "Fazer o cadastro (ou login).",
      "Finalizar e aproveitar o acesso!",
    ],
    clipboard: `Seu amigo lembrou de você e te deu de presente 1 mês de acesso grátis ao Bella da Semana! 

Lá você terá acesso ilimitado a fotos e vídeos de modelos Brasileiras deslumbrantes e completamente nuas, com a qualidade inigualável do maior clube do Brasil. É o melhor conteúdo do gênero, sem comparação.

Para ativar seu presente, é só seguir os passos abaixo usando este link exclusivo:

[ SEU LINK EXCLUSIVO AQUI ]

Como ativar seu presente:

- Clique no link acima 
- Selecione o Plano Basic (opção Mensal)
- Faça seu cadastro ou login
- Preencha os dados e pronto 

Você receberá um mês de assinatura gratuita!`,
    modalUpgradeText0: 'Aproveite seu bônus e turbine',
    modalUpgradeText1: 'sua assinatura do Bella da Semana!',
    modalUpgradeText2: 'Seu plano é',
    modalUpgradeText3: 'e você tem',
    modalUpgradeText4: 'de bônus para realizar o upgrade.',
    modalUpgradeText5: 'QUERO FAZER UPGRADE',
    modalInviteText1: 'Presenteie o seu melhor',
    modalInviteText2: 'amigo com um mês de',
    modalInviteText3: 'Bella da Semana GRÁTIS',
    modalInviteText4: 'Agora você pode presentear aquele seu',
    modalInviteText5: 'parceiro com 1 mês de assinatura gratuita.',
    modalInviteText6: 'CLIQUE AQUI E PRESENTEIE SEU AMIGO',
    modalCreditText1: '50% de DESCONTO',
    modalCreditText2: 'Créditos para Download',
    modalCreditText3: 'Como assinante do Bella da Semana, liberamos para você 50% de desconto na compra de créditos para download.',
    modalCreditText4: 'Baixe os vídeos e making of em 4k e lives em HD, para assistir quando quiser, sem depender de internet.',
    modalCreditText5: 'QUERO CRÉDITOS PELA METADE DO PREÇO',
    modalCouponText1: 'QUERO ASSINAR',
    myCardsTitle: "Meus Cartões",
    myCardsSubtitle:
      "Aqui você pode conferir e trocar o cartão de crédito da sua assinatura.",
    myCardsEmpty:
      "Nenhum cartão cadastrado. O cartão é associado à sua conta quando você assina com cartão de crédito.",
    myCardsRecurrenceNote:
      "A renovação automática da sua assinatura usará este cartão.",
    myCardsChangeButton: "Trocar cartão",
    myCardsCancelButton: "Cancelar",
    myCardsConfirmButton: "Salvar novo cartão",
    myCardsSuccess: "Cartão atualizado com sucesso!",
    myCardsHolder: "Titular",
    myCardsValidity: "Validade",
    myCardsBrand: "Bandeira",
    myCardsLoadError:
      "Não foi possível carregar seu cartão. Tente novamente mais tarde.",
    myCardsRetry: "Tentar novamente",
  },
  ingles: {
    passosCodeShare: [
      "Click on your invitation link.",
      "Choose the Basic Plan (monthly option).",
      "Register (or login).",
      "Finish and enjoy the access!",
    ],
    shareCodeSubtitle1:
      "Gift your best friend with <strong>1 month free at Clube Bella!<strong/><br>It's very simple: generate your gift code and send it to him.",
    title: "my account",
    buttonCredits: "Click here",
    subTitle: "Enter your access details below.",
    placeHolderEmail: "Enter your email / login",
    placeHolderPassword: "Enter your password",
    codeshare: "Invite your friend",
    titleBanner: "Subscribe Now!",
    subTitleBanner: "It’s easy, fast, and safe.",
    legendBanner: "Choose the best plan for you and subscribe right now!",
    buttonLabel: "Enter",
    labelInformation:
      "My Account is an area dedicated to Bella da Semana subscribers. Here you can:",
    listActivity: [
      "Check your subscription payment history",
      "Catch up on your Bella Club subscription",
      "Print the 2nd copy of the bank slip",
      "Update your registration details (email and password)",
    ],
    imgDefault: {
      name: "Model Name",
      src: "https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg",
    },
    imgBannerRodape: {
      name: "Banner Footer Name",
      src: "https://api.belladasemana.com.br/storage/banners/1539015349.jpg",
    },
    hello: "Hello",
    sweetDo: "choose what you want to do",
    navBarAreaGold: "GOLD Area",
    navBar: [
      "Renew / Upgrade",
      "Download Credits",
      /*"Cancel subscription",*/
      /*'Change payment method', 'Change plan',*/ "Purchase history",
      "Change registration data",
      "Invite your friend",
    ],
    historyTitle: "My purchase history",
    historySubtitle: "Here you can check all your payments made.",
    userSubtitle: "Here you can check all your account data. ",
    placeholderNickname: "Nickname",
    placeholderEmail: "Your email",
    labelNewsletter: "Receive newsletter:",
    labelPromotions: "Receive promotions:",
    yes: "Yes",
    no: "No",
    placeholderPassword: "New password",
    placeholderRepitePassword: "Retype your password",
    placeholderCurrentPassword: "Current password",
    msgCurrentPasswordRequired:
      "Enter your current password to change your password.",
    msgNewPasswordRequired:
      "Enter the new password and its confirmation to change your password.",
    msgPasswordMismatch: "The new password and its confirmation do not match.",
    buttonLabelSave: "Save",
    titleCancel: "Don't you want to subscribe to Bella anymore?",
    subtitleCancel:
      "If you are sure you want to cancel your subscription, confirm below:",
    infoCancel1:
      "The cancellation takes effect at the end of this billing cycle:",
    labelOptionCancel: "Select the reason for canceling your subscription:",
    buttonLabelCancel: "Request cancellation",
    inputCancelMessage: "Other (specify below)",
    infoCancel2:
      "Come back whenever you want. If you restart your subscription within 2 months, your profiles, bookmarks, preferences and account details will be waiting for you.",
    listMotivosCancel: [
      "Subscription price",
      "Quality of rehearsals",
      "Little nudity",
      "Frequency of updates",
      "Content different from what I expected",
      "I am satisfied with the open content",
      "Difficulty accessing",
      "Others (specify below)",
    ],
    listMotivosCancelName: [
      "price",
      "quality",
      "little_nudity",
      "updates_frequency",
      "expected_different_content",
      "satisfied_opened_content",
      "difficult_access",
      "none_above",
    ],
    forgotPwd1: "If you forgot your password, ",
    forgotPwd2: "click here",
    orderType: "Type",
    orderStatus: "Status",
    orderPlanName: "Plan",
    orderPlanValue: "Value",
    orderMethodName: "Payment method",
    orderStart: "Start",
    orderFinish: "End",
    noOrders: 'No orders found',
    alertMessageOrderActived:
      "You already have an active subscription! It is only possible to renew after expiration on the day: ",
    placeholderMessage: "Message",
    setReasonCancel: "Please provide a reason!",
    setMessageReasonCancel: "Please provide other reasons in the Message!",
    cancelAttention: "Attention!",
    notCancelledYet:
      "Your membership <b>STILL HAS NOT BEEN CANCELED!</b><br><br> A confirmation e-mail will be sent to your email.<br> Please verify your Spam or Bin.<br><br> <b>IN ORDER TO CONFIRM YOUR REQUEST,<br> YOU MUST CLICK ON THE LINK THAT WAS SENT TO YOU BY E-MAIL.</b>",
    notSubscribe: "No active subscriptions.",
    msgWaiting: "Wait for processing...",
    msgSendMail: "Enter your email below",
    btnSendMail: "Send",
    btnClose: "Close",
    pwdReset: "Password Reset",
    formResetEmail: "E-mail",
    formResetPwd: "New Password",
    formResetPwdConfirm: "Confirm your password",
    formResetButton: "Save",
    checkFailedText1: "Link expired!",
    checkFailedText2: "Please repeat the password recovery procedure.",
    checkFailedText3: "Go to password reset page",
    msgSuccess: "Go to login page",
    footer1ModalPlan: "jÁ É SÓCIO?",
    footer2ModalPlan: " FAÇA LOGIN PARA COMPRAR CRÉDITOS COM DESCONTO",
    clipboard: `Your friend remembered you and gave you 1 month of free access to Bella Club!


There you'll have unlimited access to photos and videos of stunning, completely nude models, with the unparalleled quality of Brazil's largest men's club. It's the best content of its kind, beyond compare.


To activate your gift, just follow the steps below using this exclusive link:


[ SEU LINK EXCLUSIVO AQUI ]


How to activate your gift:


- Click on the link above
- Select the Basic Plan (Monthly option)
- Register or log in
- Fill in the details and that's it


You will receive a free month of subscription!`,
    modalUpgradeText0: 'Enjoy your bonus and boost',
    modalUpgradeText1: 'your Bella Club subscription!',
    modalUpgradeText2: 'Your current plan is',
    modalUpgradeText3: 'and you have',
    modalUpgradeText4: ' in bonus credit to upgrade.',
    modalUpgradeText5: 'I WANT TO UPGRADE',
    modalInviteText1: 'Gift your best',
    modalInviteText2: 'friend a month of',
    modalInviteText3: 'Bella Club FREE',
    modalInviteText4: 'Now you can gift your partner',
    modalInviteText5: 'a month of free subscription.',
    modalInviteText6: 'CLICK HERE AND GIFT YOUR FRIEND',
    modalCreditText1: '50% OFF',
    modalCreditText2: 'Download Credits',
    modalCreditText3: 'As a Bella Club subscriber, we\'re giving you a 50% discount on download credits.',
    modalCreditText4: 'Download videos and behind-the-scenes footage in 4K and live streams in HD to watch whenever you want, without the need for an internet connection.',
    modalCreditText5: 'I WANT HALF-PRICE CREDITS',
    modalCouponText1: 'I WANT TO SUBSCRIBE',
    myCardsTitle: "My Cards",
    myCardsSubtitle:
      "Here you can check and change your subscription's credit card.",
    myCardsEmpty:
      "No card on file. A card is associated with your account when you subscribe with a credit card.",
    myCardsRecurrenceNote: "Your subscription auto-renewal will use this card.",
    myCardsChangeButton: "Change card",
    myCardsCancelButton: "Cancel",
    myCardsConfirmButton: "Save new card",
    myCardsSuccess: "Card updated successfully!",
    myCardsHolder: "Holder",
    myCardsValidity: "Valid thru",
    myCardsBrand: "Card brand",
    myCardsLoadError: "We could not load your card. Please try again later.",
    myCardsRetry: "Try again",
  },
};

export default translate;
